import { Component, Input } from '@angular/core'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { Store } from '@ngrx/store'
import { JobApiService } from '../../../shared/services/job-api.service'
import { ToasterService } from '../../../shared/services/toaster.service'
import { Observable, takeUntil, Subject } from 'rxjs'
import {
    JobSelectionListItem,
    selectJobSelectionOptions,
} from '../../../state/selection/selection.selectors'
import { HttpErrorResponse } from '@angular/common/http'
import { JobSelectionRef, PipelineType } from '../../../shared/model/jobs'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-neighborhood-enrichment-selection',
    templateUrl: './neighborhood-enrichment-selection.component.html',
    styleUrls: ['./neighborhood-enrichment-selection.component.scss'],
})
export class NeighborhoodEnrichmentSelectionComponent {
    @Input()
    siblingDatasets: string[] | never[]
    selections$: Observable<JobSelectionListItem[]>
    private selectedSelections: JobSelectionRef[] | null = null

    experimentName = ''
    keepBackground = true
    radius = 1
    submitted = false
    runBatchJob: boolean = false

    private readonly wikiUrl = environment.wikiUrl
    private readonly onDestroy$ = new Subject<void>()

    constructor(
        private store: Store,
        private readonly jobApi: JobApiService,
        private readonly toaster: ToasterService
    ) {
        this.selections$ = this.store
            .select(selectJobSelectionOptions)
            .pipe(takeUntil(this.onDestroy$))
    }

    get canStart(): boolean {
        return (
            this.radius > 0 &&
            this.experimentName.length > 0 &&
            !!this.selectedSelections &&
            this.selectedSelections.length > 0 &&
            !this.submitted
        )
    }

    cancel(): void {
        closeJobSelectionDialog()
    }

    startJob(): void {
        if (!this.canStart) return
        this.submitted = true

        this.jobApi
            .startNeighborhoodEnrichmentJob({
                type: PipelineType.NeighborhoodEnrichment,
                selections: this.selectedSelections!,
                experimentName: this.experimentName,
                keepBackground: this.keepBackground,
                radius: this.radius,
                batch: this.runBatchJob,
            })
            .subscribe({
                next: () => closeJobSelectionDialog(),
                error: (err: HttpErrorResponse) => {
                    this.toaster.httpError(err, 'Error starting job')
                },
            })
    }

    selectSelections(selections: JobSelectionListItem[]): void {
        this.selectedSelections = selections.map(({ id, type, path }) => ({ id, type, path }))
    }

    goToWiki(): void {
        window.open(
            `${this.wikiUrl}home/Navigation#clustering-analysis-neighborhood-enrichment`,
            '_blank'
        )
    }
}
